(function () {
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function formatPrice(price) {
    return parseFloat(price).toFixed(2).replace('.', ',');
  }

  // Shopify serves the original (often multi-MB) upload unless a size is
  // requested — that's the real cause of "loading between articles" lag,
  // not network round-trips, since the whole queue is already fetched
  // upfront. The feed template already asks for the width that actually
  // fits the card.
  function getImageUrl(entry) {
    return (entry && entry.image) || '';
  }

  // Warms the browser's image cache for upcoming cards so swiping past the
  // current one feels instant instead of waiting on a fresh download.
  function preloadImage(entry) {
    const url = getImageUrl(entry);
    if (!url) return;
    const img = new Image();
    img.src = url;
  }

  const CATEGORY_LABELS = {
    'vintage-jeans': 'Jeans',
    'vintage-polos-shirts': 'Polos & Shirts',
    'pullover-sweater': 'Pullover & Sweater',
    'vintage-jacken-mantel': 'Jacken & Mäntel',
    'vintage-accessoires-1': 'Accessoires',
    'alle-artikel': 'Alle Artikel',
  };

  // Enough to cover the largest collection (Alle Artikel) at the 50-per-page
  // ceiling Liquid's paginate tag imposes.
  const MAX_FEED_PAGES = 40;

  // These are one-off vintage pieces: each product has a single variant
  // whose "option" is just the garment's measurements, not a real size.
  // The size instead lives at the end of the product title, e.g.
  // "Vintage Levi's Baggy Jeans „501“ (M)" — match against that instead.
  function getProductSize(title) {
    const match = title.match(/\(([A-Za-z0-9]{1,4})\)\s*$/);
    return match ? match[1].toUpperCase() : null;
  }

  function matchesSize(entry, size) {
    return getProductSize(entry.title) === size.toUpperCase();
  }

  // Gender comes from the product metafield custom.geschlecht, which is the
  // maintained source of truth. The old "Mann"/"Frau" tags are NOT consulted
  // while a metafield value exists — they contradict each other on dozens of
  // products, which is exactly why the slider used to show the wrong gender.
  //
  // Unisex pieces deliberately appear under both selections. Products with no
  // value yet fall back to the tag, and if they carry no gender tag either
  // they stay visible to everyone rather than silently dropping out of the
  // shop. Values are trimmed because some are stored as e.g. "Frau ".
  function matchesGender(entry, wanted) {
    const target = String(wanted || '').trim().toLowerCase();
    const gender = String(entry.gender || '').trim().toLowerCase();

    if (gender) return gender === target || gender === 'unisex';

    const tags = (entry.tags || []).map((tag) => String(tag).trim().toLowerCase());
    const tagged = tags.indexOf('mann') !== -1 || tags.indexOf('frau') !== -1;
    if (!tagged) return true;
    return tags.indexOf(target) !== -1;
  }

  // Mirrors collection-quick-add.js's silent cart-drawer update so a swipe
  // "like" feels consistent with the rest of the site's quick-add — the
  // drawer content refreshes in the background without popping open.
  function updateCartSectionsSilently(parsedState) {
    if (!parsedState.sections) return;

    const cartDrawerRoot = document.getElementById('CartDrawer');
    if (cartDrawerRoot && parsedState.sections['cart-drawer']) {
      const parsed = new DOMParser()
        .parseFromString(parsedState.sections['cart-drawer'], 'text/html')
        .querySelector('#CartDrawer');
      if (parsed) cartDrawerRoot.innerHTML = parsed.innerHTML;
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
      const parsed = new DOMParser()
        .parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (parsed) cartIconBubble.innerHTML = parsed.innerHTML;
    }

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.classList.remove('is-empty');
      const inner = cartDrawerEl.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
  }

  function showAddedToCartToast() {
    const existing = document.getElementById('OnhowAddedToast');
    if (existing) existing.remove();
    clearTimeout(window.__onhowToastTimeout);

    const cartIcon = document.querySelector('#cart-icon-bubble');
    const toast = document.createElement('div');
    toast.id = 'OnhowAddedToast';
    toast.className = 'onhow-added-toast';
    toast.innerHTML =
      '<span class="onhow-added-toast__icon" aria-hidden="true">&#10003;</span>' +
      '<span class="onhow-added-toast__text">Erfolgreich in den <a href="/cart" class="onhow-added-toast__link">Warenkorb</a> hinzugef&uuml;gt</span>';
    document.body.appendChild(toast);

    if (cartIcon) {
      const rect = cartIcon.getBoundingClientRect();
      toast.style.top = `${Math.round(rect.bottom + 10)}px`;
      toast.style.right = `${Math.round(window.innerWidth - rect.right)}px`;
    }

    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.__onhowToastTimeout = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  function pulseCartIcon() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;
    cartIcon.classList.remove('onhow-cart-pulse');
    // eslint-disable-next-line no-void
    void cartIcon.offsetWidth;
    cartIcon.classList.add('onhow-cart-pulse');
    setTimeout(() => cartIcon.classList.remove('onhow-cart-pulse'), 400);
  }

  async function addToCart(variantId) {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cartDrawer && cartDrawer.getSectionsToRender) {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const json = await res.json();
      if (json.status) return;

      updateCartSectionsSilently(json);
      showAddedToCartToast();
      pulseCartIcon();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'swipe-discovery', cartData: json });
      }
    } catch (error) {
      console.error(error);
    }
  }

  function init() {
    const fab = document.getElementById('SwipeDiscoveryFab');
    const panel = document.getElementById('SwipeDiscoveryPanel');
    if (!fab || !panel) return;

    const closeBtn = panel.querySelector('.swipe-discovery-panel__close');
    const filtersLink = document.getElementById('SwipeDiscoveryFiltersLink');
    const filterStep = panel.querySelector('[data-step="filters"]');
    const cardsStep = panel.querySelector('[data-step="cards"]');
    const startBtn = panel.querySelector('.swipe-discovery-start');
    const stack = document.getElementById('SwipeDiscoveryStack');
    const skipBtn = document.getElementById('SwipeDiscoverySkip');
    const likeBtn = document.getElementById('SwipeDiscoveryLike');

    let selectedSize = null;
    let selectedGender = null;
    let selectedCategory = null;
    let queue = [];
    let currentEntry = null;
    let liveCard = null;
    let dragging = false;
    let dragStartX = 0;
    let dragDeltaX = 0;

    function updateStartButton() {
      const ready = Boolean(selectedSize && selectedGender && selectedCategory);
      startBtn.disabled = !ready;
      startBtn.textContent = ready ? 'Los geht’s →' : 'Bitte Größe, Geschlecht & Kategorie wählen';
    }

    panel.querySelectorAll('[data-pill-group]').forEach((group) => {
      const groupName = group.dataset.pillGroup;
      group.querySelectorAll('.swipe-discovery-pill').forEach((pill) => {
        pill.addEventListener('click', () => {
          group.querySelectorAll('.swipe-discovery-pill').forEach((p) => p.classList.remove('is-selected'));
          pill.classList.add('is-selected');
          if (groupName === 'size') selectedSize = pill.dataset.value;
          else if (groupName === 'gender') selectedGender = pill.dataset.value;
          else selectedCategory = pill.dataset.value;
          updateStartButton();
        });
      });
    });

    function openPanel() {
      panel.hidden = false;
      document.body.classList.add('swipe-discovery-open');
    }

    function closePanel() {
      panel.hidden = true;
      document.body.classList.remove('swipe-discovery-open');
    }

    fab.addEventListener('click', openPanel);
    closeBtn.addEventListener('click', closePanel);

    function resetToFilters() {
      cardsStep.hidden = true;
      filterStep.hidden = false;
      filtersLink.hidden = true;
    }

    filtersLink.addEventListener('click', resetToFilters);

    async function fetchFeedPage(collectionHandle, page) {
      const res = await fetch(`/collections/${collectionHandle}?view=swipe&page=${page}`);
      return JSON.parse(await res.text());
    }

    // The feed template is capped at 50 products per page by Liquid's
    // paginate tag, so the first response is used to learn the page count and
    // the remainder is fetched in parallel — one extra round-trip instead of
    // one per page. Cached for the session so reopening the slider is
    // instant.
    async function fetchCandidates(collectionHandle) {
      const cacheKey = `onhowSwipeFeed:${collectionHandle}`;
      try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached) return JSON.parse(cached);
      } catch (error) {
        /* sessionStorage unavailable — just fetch */
      }

      const first = await fetchFeedPage(collectionHandle, 1);
      let all = first.products || [];
      const pages = Math.min(first.pages || 1, MAX_FEED_PAGES);

      if (pages > 1) {
        const pending = [];
        for (let page = 2; page <= pages; page++) pending.push(fetchFeedPage(collectionHandle, page));
        const results = await Promise.all(pending);
        results.forEach((result) => {
          all = all.concat(result.products || []);
        });
      }

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify(all));
      } catch (error) {
        /* over quota — the queue is already built, so this is harmless */
      }
      return all;
    }

    async function loadQueue() {
      stack.innerHTML = '<p class="swipe-discovery-loading">Passende Teile werden geladen&hellip;</p>';
      try {
        const candidates = await fetchCandidates(selectedCategory);
        queue = shuffle(
          candidates.filter(function (entry) {
            return matchesGender(entry, selectedGender) && matchesSize(entry, selectedSize);
          })
        );
      } catch (error) {
        console.error(error);
        queue = [];
      }
    }

    function showEmptyState() {
      liveCard = null;
      stack.innerHTML =
        '<div class="swipe-discovery-empty">' +
        '<p>Keine passenden Artikel in dieser Kombination gefunden.</p>' +
        '<p>Versuch es mit einer anderen Gr&ouml;&szlig;e, Geschlecht oder Kategorie.</p>' +
        '<button type="button" class="swipe-discovery-restart">Zur&uuml;ck zur Auswahl</button>' +
        '</div>';
      stack.querySelector('.swipe-discovery-restart').addEventListener('click', resetToFilters);
    }

    function showEndState() {
      stack.innerHTML =
        '<div class="swipe-discovery-end">' +
        '<p>Das war’s erstmal! 🎉</p>' +
        '<p>Schau sp&auml;ter wieder vorbei f&uuml;r neue Teile.</p>' +
        '<button type="button" class="swipe-discovery-restart">Nochmal von vorne</button>' +
        '</div>';
      stack.querySelector('.swipe-discovery-restart').addEventListener('click', resetToFilters);
    }

    function renderNextCard() {
      if (queue.length === 0) {
        showEndState();
        liveCard = null;
        return;
      }
      currentEntry = queue.shift();

      Array.from(stack.children).forEach((child) => {
        if (!child.classList.contains('swipe-discovery-card')) child.remove();
      });

      const image = getImageUrl(currentEntry);

      const categoryLabel = CATEGORY_LABELS[selectedCategory] || '';
      const vendorBadge = currentEntry.vendor
        ? `<span class="swipe-discovery-card__vendor-badge">${currentEntry.vendor}</span>`
        : '';
      const categoryLine = categoryLabel
        ? `<span class="swipe-discovery-card__category">${categoryLabel}</span>`
        : '';

      const card = document.createElement('div');
      card.className = 'swipe-discovery-card';
      card.style.zIndex = '1';
      card.style.backgroundImage = `url('${image}')`;
      card.innerHTML =
        vendorBadge +
        '<div class="swipe-discovery-card__overlay">' +
        categoryLine +
        `<h3 class="swipe-discovery-card__title">${currentEntry.title}</h3>` +
        `<span class="swipe-discovery-card__price">&euro;${formatPrice(currentEntry.price)}</span>` +
        '</div>';
      stack.appendChild(card);
      liveCard = card;

      preloadImage(queue[0]);
      preloadImage(queue[1]);
    }

    function flingCard(card, direction) {
      if (!card) return;
      card.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
      card.style.transform = `translateX(${direction * 600}px) rotate(${direction * 20}deg)`;
      card.style.opacity = '0';
    }

    function advance(direction) {
      const leaving = liveCard;
      liveCard = null;
      currentEntry = null;

      if (leaving) {
        leaving.style.pointerEvents = 'none';
        leaving.style.zIndex = '2';
        flingCard(leaving, direction);
        setTimeout(() => leaving.remove(), 320);
      }

      renderNextCard();
    }

    function handleLike() {
      if (!currentEntry) return;
      addToCart(currentEntry.id);
      advance(1);
    }

    function handleSkip() {
      if (!currentEntry) return;
      advance(-1);
    }

    likeBtn.addEventListener('click', handleLike);
    skipBtn.addEventListener('click', handleSkip);

    let moveWatchdogId = null;

    function clearMoveWatchdog() {
      if (moveWatchdogId) {
        clearTimeout(moveWatchdogId);
        moveWatchdogId = null;
      }
    }

    function armMoveWatchdog() {
      clearMoveWatchdog();
      moveWatchdogId = setTimeout(endDrag, 400);
    }

    stack.addEventListener('pointerdown', (event) => {
      const card = event.target.closest('.swipe-discovery-card');
      if (!card || card !== liveCard) return;
      dragging = true;
      dragStartX = event.clientX;
      dragDeltaX = 0;
      card.style.transition = 'none';
      card.setPointerCapture(event.pointerId);
      armMoveWatchdog();
    });

    stack.addEventListener('pointermove', (event) => {
      if (!dragging || !liveCard) return;
      dragDeltaX = event.clientX - dragStartX;
      liveCard.style.transform = `translateX(${dragDeltaX}px) rotate(${dragDeltaX / 20}deg)`;
      armMoveWatchdog();
    });

    function endDrag() {
      clearMoveWatchdog();
      if (!dragging) return;
      dragging = false;
      const card = liveCard;
      if (!card) return;
      card.style.transition = 'transform 0.3s ease';

      if (dragDeltaX > 100) {
        handleLike();
      } else if (dragDeltaX < -100) {
        handleSkip();
      } else {
        card.style.transform = '';
      }
      dragDeltaX = 0;
    }

    stack.addEventListener('pointerup', endDrag);
    stack.addEventListener('pointercancel', endDrag);
    stack.addEventListener('lostpointercapture', endDrag);

    startBtn.addEventListener('click', async () => {
      if (startBtn.disabled) return;
      filterStep.hidden = true;
      cardsStep.hidden = false;
      filtersLink.hidden = false;
      await loadQueue();
      if (queue.length === 0) {
        showEmptyState();
      } else {
        renderNextCard();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
